import { useState, type ReactNode } from 'react';

import { Sidebar } from './sidebar';
import { Topbar } from './topbar';

export function Shell({ children }: { readonly children: ReactNode }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="nw-shell">
      <Sidebar open={drawerOpen} onNavigate={() => setDrawerOpen(false)} />
      {drawerOpen && (
        <div
          className="nw-shell__backdrop"
          onClick={() => setDrawerOpen(false)}
          aria-hidden="true"
        />
      )}
      <div className="nw-shell__main">
        <Topbar onMenu={() => setDrawerOpen((v) => !v)} />
        <main className="nw-shell__content">{children}</main>
      </div>
    </div>
  );
}
